import { getTranslations } from 'next-intl/server';
import { ReviewsSortingOption } from '@headless-workspace/config';
import { PredicateHelpers } from '@headless-workspace/utils';
import { ReviewSortOption } from '../RatingsAndReviewsValue';

const order: ReviewsSortingOption[] = [
    ReviewsSortingOption.MostRecent,
    ReviewsSortingOption.LeastRecent,
    ReviewsSortingOption.BestRated,
    ReviewsSortingOption.WorstRated,
];

export const mapSortingOptions = async (sorting: { id: string; label: string }[]): Promise<ReviewSortOption[]> => {
    const t = await getTranslations('Discover.Pdp.ratingAndReviews');

    const sortingOptionLabels: Record<ReviewsSortingOption, string> = {
        [ReviewsSortingOption.MostRecent]: t('label.mostRecent'),
        [ReviewsSortingOption.LeastRecent]: t('label.leastRecent'),
        [ReviewsSortingOption.BestRated]: t('label.bestRated'),
        [ReviewsSortingOption.WorstRated]: t('label.worstRated'),
    };

    return order
        .map((sortOption) => {
            const item = sorting.find((sortingItem) => sortingItem.id === sortOption);
            if (!item) {
                return null;
            }

            return {
                value: sortingOptionLabels[sortOption],
                label: sortingOptionLabels[sortOption],
                tag: sortOption,
            };
        })
        .filter(PredicateHelpers.notNullOrUndefined);
};
